<template>
    <div>
        
        <div class="videoShowContainer" >
            <div class="delete is-large" style="position: absolute; top: 5px; left: 5px; background-color: black; z-index: 50" @click="$root.$refs.routerView.closeVideo"></div>
            
          <!--  <div itemscope itemtype="https://schema.org/VideoObject">
            <meta itemprop="uploadDate" content="Tue Apr 26 2022 12:12:00 GMT-0400 (Eastern Daylight Time)"/>
            <meta itemprop="name" content="Slink Use Case"/>
            <meta itemprop="description" content="Slink - Short, Simple links everyone can remember. Create easily rememberable shortcuts to your calls to action! Own Your Words."/>
            <meta itemprop="duration" content="P0Y0M0DT0H1M16S" />
            <meta itemprop="thumbnailUrl" content="https://content.jwplatform.com/thumbs/WUIYAZp9-1920.jpg"/>
            <meta itemprop="contentUrl" content="https://content.jwplatform.com/videos/WUIYAZp9-ZwDaX2fG.mp4"/>
           </div> -->
    
           <video class="videoPlayer" id="htmlVideo" :src="$root.$refs.routerView.vid" controls autoplay poster="@/assets/img/vidPoster.png"></video>
        </div>
    </div>
</template>

<script>

import sl from '../components/ScriptLoader.vue'

export default {
    mounted: function(){
        //this.$root.loadScript('https://cdn.jwplayer.com/players/WUIYAZp9-CcMp2cPq.js', function(){return true})
    }
}

</script>


// WEBPACK FOOTER //
// src/components/Video1.vue